import clsx from "clsx";
import { FC } from "react";

import type { InterruptEvent } from "@tsmono/inspect-common/types";
import { formatDateTime, getOwn } from "@tsmono/util";

import { EventPanel } from "./event/EventPanel";
import { EventNode } from "./types";

interface InterruptEventViewProps {
  eventNode: EventNode<InterruptEvent>;
  className?: string;
}

type InterruptSource = InterruptEvent["source"];
type Interrupted = InterruptEvent["interrupted"];

const SOURCE_TITLES: Record<InterruptSource, string> = {
  user_cancel: "Interrupted by user",
  limit: "Interrupted by limit",
  system: "Interrupted by system",
};

const INTERRUPTED_DESCRIPTIONS: Record<Interrupted, string> = {
  generate: "during model generation",
  tool_call: "during tool execution",
  between_turns: "between turns",
};

export const InterruptEventView: FC<InterruptEventViewProps> = ({
  eventNode,
  className,
}) => {
  const event = eventNode.event;
  const baseTitle = getOwn(SOURCE_TITLES, event.source) ?? "Interrupted";
  const title = event.timestamp
    ? `${baseTitle} — ${formatDateTime(new Date(event.timestamp))}`
    : baseTitle;
  const detail = getOwn(INTERRUPTED_DESCRIPTIONS, event.interrupted);

  return (
    <EventPanel
      eventNodeId={eventNode.id}
      title={title}
      icon="interrupt"
      className={className}
    >
      <div className={clsx("text-size-smaller")}>{detail}</div>
    </EventPanel>
  );
};
